import { createFileRoute } from '@tanstack/react-router'
import LanguageTestPage from '@/spa/pages/LanguageTestPage'
import { routeErrorComponent } from './_shared/RouteError'

export const Route = createFileRoute('/language-test')({
  component: LanguageTestPage,
  errorComponent: routeErrorComponent,
})
